import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { accountState, teamMembers } from "actions/members";
import userProfile from "services/user.profile";
import ContentHeader from "pages/Profile/components/ContentHeader";
import Modal from "components/Modal";
import Message from "components/Message";
import Form from "../Form";
import { ModalChangeState } from "../Modals";

import styles from "./EditMember.module.scss";

const EditMember = ({ memberDetails, setCurrentScreen }) => {
  const dispatch = useDispatch();
  const defaultValue = {
    first_name: memberDetails?.first_name,
    last_name: memberDetails?.last_name,
    is_active: memberDetails?.is_active,
  };
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [personalInfo, setPersonalInfo] = useState(defaultValue);
  const [showMessage, setShowMessage] = useState(false);

  const employees = useSelector((state) => state.members);

  useEffect(() => {
    memberDetails?.id && dispatch(accountState(memberDetails.id));
  }, [dispatch, memberDetails?.id]);

  const handleChangeStatus = (id) => {
    if (personalInfo.is_active) {
      setShowModal(true);
      setModalData({ id, status: personalInfo.is_active });
    } else {
      userProfile
        .changeProfileMember(id, {
          is_active: !personalInfo.is_active,
        })
        .then(
          (res) => {
            dispatch(teamMembers);
            setPersonalInfo({
              ...personalInfo,
              is_active: !personalInfo.is_active,
            });
            setShowMessage(true);

            setTimeout(() => setShowMessage(false), 3000);
          },
          ({ response }) => {
            console.error("Edit member error:", response);
          },
        );
    }
  };

  return (
    <>
      <ContentHeader
        title={`${personalInfo.first_name} ${personalInfo.last_name}`}
        details={`Last Login: ${memberDetails.last_login ?? "0 h ago"}`}
        buttonText={
          personalInfo?.is_active ? "Deactivate Team Member" : "Activate Team Member"
        }
        handleClickBack={() => setCurrentScreen("")}
        onClick={() => handleChangeStatus(memberDetails.id)}
        state={personalInfo?.is_active}
        className={styles.header}
      />

      <div className={styles.wrapper}>
        <Form
          data={memberDetails}
          id={memberDetails?.id}
          state="edit"
          setPersonalInfo={setPersonalInfo}
          hasAccount={employees?.hasAccount?.has_account}
        />
      </div>

      {showModal && (
        <Modal
          setShowModal={setShowModal}
          className={styles.modal}
          content={
            <ModalChangeState
              data={modalData}
              setShowModal={setShowModal}
              personalInfo={personalInfo}
              setPersonalInfo={setPersonalInfo}
            />
          }
        />
      )}

      {showMessage && <Message text="Your changes have been successfully saved!" />}
    </>
  );
};

export default EditMember;
